/* eslint-disable no-console */
import axios from 'axios';
import {HOST} from '../constants';

const http = axios.create({});
http.defaults.withCredentials = true;
axios.defaults.withCredentials = true;

// eslint-disable-next-line
export const httpGet = (url: string, options: any = {}): Promise<any> => {
    return http.get(`${HOST}/${url}`, options).then((response) => response.data);
};

// eslint-disable-next-line
export const httpPost = (url: string, data?: any, headers = {}): Promise<any> => {
    return http.post(`${HOST}/${url}`, data, {headers}).then((response) => response.data);
};

// eslint-disable-next-line
export const httpPut = (url: string, data?: any, headers = {}): Promise<any> => {
    return http.put(`${HOST}/${url}`, data, {headers}).then((response) => response.data);
};

// eslint-disable-next-line
export const httpDelete = (url: string, data: any, headers = {}): Promise<any> => {
    return http.delete(`${HOST}/${url}`, {headers, data}).then((response) => response.data);
};

// eslint-disable-next-line
export const httpPostWithoutIntercept = (url: string, data?: any, options = {}): Promise<any> => {
    return axios.post(`${HOST}/${url}`, data, options).then((response) => response.data);
};

// eslint-disable-next-line
export const httpGetWithoutIntercept = (url: string, options: any = {}): Promise<any> => {
    return axios.get(`${HOST}/${url}`, options).then((response) => response.data);
};
